import { Container, Box } from '@mui/material';

function Contact() {
    return (
        <>
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>

                <Box mt={3}>
                    <p className='pp-3'>
                        At NVXO, we are committed to providing exceptional service and support to our users. Whether you require assistance with using our wallet, are encountering an issue, or wish to learn more about our offerings, we are here to assist you every step of the way.
                    </p>
                </Box>

                <Box mt={3}>
                    <h1 className='pp-1'>
                        Contact Us
                    </h1>
                    <p className='pp-3'>
                        For any inquiries or support needs, please do not hesitate to reach out to our dedicated support team. We are available to offer prompt, dependable, and secure assistance to ensure that your experience with NVXO remains seamless and enjoyable.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Email:
                    </h5>
                    <p className='pp-3'>
                        For general inquiries, feedback, and support requests, please contact us at
                        <a style={{ marginLeft: "10px", textDecoration: "underline" }} href="mailto:It@aegeaholdings.com">It@aegeaholdings.com</a>
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Support Channels
                    </h5>
                    <p className='pp-3'>
                        We take your security and satisfaction seriously and offer multiple support channels to address a variety of requests. Each inquiry is handled with the utmost priority, whether you require technical assistance, have questions about your account, or need information about our services.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Technical Support:
                    </h5>
                    <p className='pp-3'>
                        Should you experience any technical difficulties, such as issues with transactions or accessing your account, please contact our technical support team at
                        <a style={{ marginLeft: "10px", textDecoration: "underline" }} href="mailto:It@aegeaholdings.com">It@aegeaholdings.com</a>
                    </p>
                    <p className='pp-3'>
                        We aim to resolve your issues swiftly, with a dedicated team ready to provide assistance.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Account Assistance
                    </h5>
                    <p className='pp-3'>
                        For inquiries related to your account, including security concerns, transaction issues, or verification, our account assistance specialists are available to support you.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Feedback and Suggestions
                    </h5>
                    <p className='pp-3'>
                        We welcome and appreciate your feedback. If you have suggestions or ideas on how we can improve NVXO Wallet, please do not hesitate to share them by emailing us at
                        <a style={{ marginLeft: "10px", textDecoration: "underline" }} href="mailto:It@aegeaholdings.com">It@aegeaholdings.com</a>
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2' mb={1}>
                        Our Commitment to You
                    </h5>
                    <p className='pp-3'>
                        Your trust is fundamental to our mission, and we prioritize your satisfaction in all interactions. We ensure that every communication with us is secure and confidential, with a team dedicated to safeguarding the privacy and integrity of your information. We strive to foster a relationship with our users built on reliability, security, and transparency.
                    </p>
                </Box>

                <Box mt={3}>
                    <p className='pp-3' mb={1}>
                        Thank you for choosing NVXO. We look forward to serving you and supporting your needs.
                    </p>
                </Box>

            </Container>
        </>
    );
}

export default Contact;
